import { MultiLangText } from "src/utils/types"
import { EducationCategory } from "../../entities/educationCategory"
import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	id: string
	parentCategoryId?: string
	update: {
		parentCategoryId?: string
		name?: MultiLangText
	}
}

export async function educationCategoryUpdateApi(
	payload: RequestDataShape,
	token: string,
) {
	const endpoint = "/educationCategory/update/v1"
	const requester = new ApiRequester<RequestDataShape, EducationCategory>(endpoint)
	const response = await requester.sendRequest(payload, token)
	return response
}
